var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.open
      ? _c(
          "div",
          {
            staticClass: "add-textarea-box row items-center",
            on: {
              click: function($event) {
                _vm.open = true
              }
            }
          },
          [
            _c("q-icon", { attrs: { name: "add" } }),
            _c("span", [_vm._v(_vm._s(_vm.$t("create_template")))])
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.errors.has("name"),
                  "error-label": _vm.errors.first("name")
                }
              },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "max:100",
                      expression: "'max:100'",
                      modifiers: { disable: true }
                    }
                  ],
                  attrs: { placeholder: _vm.$t("name"), name: "name" },
                  model: {
                    value: _vm.formData.name,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "name", $$v)
                    },
                    expression: "formData.name"
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.errors.has("text"),
                  "error-label": _vm.errors.first("text")
                }
              },
              [
                _c("q-editor", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required|min:1|max:100000",
                      expression: "'required|min:1|max:100000'",
                      modifiers: { disable: true }
                    }
                  ],
                  ref: "editor",
                  staticClass: "q-mt-lg round-borders",
                  staticStyle: { overflow: "hidden" },
                  attrs: {
                    toolbar: _vm.toolbar,
                    "toolbar-bg": "white",
                    "toolbar-text-color": "grey-7",
                    placeholder: _vm.$t("text"),
                    "toolbar-flat": ""
                  },
                  model: {
                    value: _vm.formData.content,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "content", $$v)
                    },
                    expression: "formData.content"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row justify-end q-mt-md" },
              [
                _c("q-btn", {
                  attrs: { flat: "", label: _vm.$t("abort") },
                  on: { click: _vm.reset }
                }),
                _c("q-btn", {
                  attrs: { flat: "", label: _vm.$t("save") },
                  on: { click: _vm.handleSave }
                })
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }